import React, { createContext } from 'react';
import useMute from '../Hooks/useMute';

export const MuteContext = createContext({});

export default function MuteProvider(props: { children: React.ReactChild }): JSX.Element {
  const currMute = useMute();
  return <MuteContext.Provider value={currMute}>{props.children}</MuteContext.Provider>;
}
